import React, { forwardRef, useCallback, useEffect } from "react";
import "./colorPickerPopup.scss";
import Portal from "elements/Portal";
import { ColorPickerContent } from "./ColorPickerContent";

export interface IColorPickerPopupPosition {
  x: number;
  y: number;
}

interface IColorPickerPopupProps {
  position: IColorPickerPopupPosition;
  hexColor: string;
  updateHexColor: (updatedHexColor: string | null) => void;
  closePopup: () => void;
  portalParentId?: string;
  onGestureStart?: () => void;
  onGestureEnd?: () => void;
}

const COLOR_PICKER_POPUP_HEIGHT = 335;
export const COLOR_PICKER_POPUP_WIDTH = 360;
export const COLOR_PICKER_POPUP_MARGIN = 10;
export const COLOR_PICKER_POPUP_TOTAL_HEIGHT = COLOR_PICKER_POPUP_HEIGHT + COLOR_PICKER_POPUP_MARGIN;

export const ColorPickerPopup = forwardRef<HTMLDivElement, IColorPickerPopupProps>((props, colorPickerPopupRef) => {
  const { position, hexColor, updateHexColor, closePopup, portalParentId, onGestureStart, onGestureEnd } =
    props;

  const handleKeydown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        e.stopPropagation();
        closePopup();
      }
    },
    [closePopup],
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeydown, { capture: true });
    return () => document.removeEventListener("keydown", handleKeydown, { capture: true });
  }, [handleKeydown]);

  return (
    <Portal isMounted={true} parentId={portalParentId}>
      <div
        ref={colorPickerPopupRef}
        className="color-picker-popup"
        style={{
          left: position.x,
          top: position.y,
          height: COLOR_PICKER_POPUP_HEIGHT,
        }}
        onPointerDown={e => e.stopPropagation()}
      >
        <ColorPickerContent
          hexColor={hexColor}
          updateHexColor={updateHexColor}
          onGestureStart={onGestureStart}
          onGestureEnd={onGestureEnd}
        />
      </div>
    </Portal>
  );
});

ColorPickerPopup.displayName = "ColorPickerPopup";
